<script>
import Layout from '@/router/layouts/main.vue'
import { mapState } from 'vuex'

import Roadmap from '@/components/releaseNotes/tabs/Roadmap.vue'
import Releases from '@/components/releaseNotes/tabs/releases.vue'
import Preview from '@/components/releaseNotes/tabs/release-preview.vue'
import Spinner from '@/components/general/spinner.vue'

export default {
  components: {
    Layout,
    Releases,
    Roadmap,
    Preview,
    Spinner,
  },

  data: function () {
    return {
      loading: false,
      tab: 0,
    }
  },

  computed: {
    ...mapState('releases', ['releases']),

    tabs() {
      return this.$store.getters['auth/isCurrentUserDeveloper']
        ? [
            {
              title: 'Releases',
              component: Releases,
            },
            {
              title: 'Roadmap',
              component: Roadmap,
            },
            {
              title: 'Preview',
              component: Preview,
            },
          ]
        : [
            {
              title: 'Releases',
              component: Releases,
            },
            // commented out until we have roadmap data to show users
            // {
            //   title: 'Roadmap',
            //   component: Roadmap,
            // },
          ]
    },

    embedded() {
      return Object.keys(this.$route.query).includes('embedded')
    },
  },

  async mounted() {
    this.loading = true
    if (!this.releases?.length) await this.$store.dispatch('releases/init')
    this.loading = false
  },
}
</script>

<template>
  <Layout style="padding: 0 !important; margin: 0 -15px">
    <v-container v-if="!loading" :class="{ 'embedded-container': embedded }">
      <v-row justify="center" class="w-full">
        <v-col :cols="$vuetify.breakpoint.xl ? '10' : '12'">
          <v-tabs
            v-show="!embedded"
            v-model="tab"
            background-color="transparent"
          >
            <v-tab v-for="({ title }, index) in tabs" :key="index">
              {{ title }}
            </v-tab>
          </v-tabs>
          <v-tabs-items id="releases-tab-items" v-model="tab">
            <v-tab-item v-for="({ component }, index) in tabs" :key="index">
              <component :is="component" :embedded="embedded" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <Spinner v-else class="mt-12" size="60" />
  </Layout>
</template>

<style lang="scss">
#releases-tab-items {
  background-color: transparent !important;
}

.fade-left-enter-active,
.fade-left-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.fade-left-enter, .fade-left-leave-to /* .fade-left-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateX(-20px);
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.fade-up-enter, .fade-up-leave-to /* .fade-up-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-down-enter-active,
.fade-down-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.fade-down-enter, .fade-down-leave-to /* .fade-up-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}

.embedded-container {
  max-width: 100%;
}
</style>
